<template>
  <div v-if="refinementCount" class="mb-5">
    <span class="mb-2 inline-block font-bold"
      >{{ $t('pages.category.chosen_filters') }} ({{ refinementCount }})</span
    >
    <template v-for="item of items" :key="item.attribute">
      <div
        v-for="refinement of item.refinements"
        :key="
          [
            refinement.attribute,
            refinement.type,
            refinement.value,
            refinement.operator,
          ].join(':')
        "
        class="mt-2 flex items-center justify-between"
      >
        <span class="text-sm">{{ refinement.label }}</span>
        <TrashIcon
          class="size-6 cursor-pointer text-highlight"
          @click="item.refine(refinement)"
        />
      </div>
    </template>
    <AisClearRefinements>
      <template #default="{ canRefine, refine }">
        <div class="text-right">
          <a
            v-if="canRefine"
            class="relative mt-2 inline-block cursor-pointer text-highlight after:absolute after:bottom-0.5 after:left-1/2 after:h-px after:w-full after:origin-center after:-translate-x-1/2 after:bg-current after:transition-transform after:duration-150 hover:after:scale-x-0 lg:mt-4"
            @click.prevent="refine"
            >{{ $t('pages.category.clear_filters') }}</a
          >
        </div>
      </template>
    </AisClearRefinements>
  </div>
</template>

<script setup lang="ts">
import { TrashIcon } from '@heroicons/vue/20/solid';
import { AlgoliaSelectedFilter } from '@/types/Algolia/AlgoliaSelectedFilter';
import { computed } from 'vue';

export type SelectedFiltersProps = {
  items: AlgoliaSelectedFilter[];
};

const props = defineProps<SelectedFiltersProps>();
const refinementCount = computed(
  () => props.items.map(i => i.refinements).flat().length
);
</script>
